<template>
  <div id="app">
    <Header/>

    <transition name="router-anim" mode="out-in">
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
import Rutinas from "./components/Rutinas.vue";
import Header from "./components/Header.vue";
export default {
  name: "app",
  components: {
    Rutinas,
    Header
  }
};
</script>
<style lang="scss" scoped>
.router-anim-enter-active {
  animation: coming .5s;
  animation-delay: 0.1s;
  opacity: 0;
}

.router-anim-leave-active {
  animation: going .5s;
}
</style>

